module.exports = __webpack_public_path__ + "img/car_front_left.263902bb.svg";